import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useBillingProvider} from "../hooks/useBillingProvider.ts";
import {BillingProvider} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useBillingProvider();

    // No id: a new record has none, and CreateBillingProviderInput does not declare one.
    // The status is set by buildCreateBillingProviderInput.
    return (
        <FormDrawer
            record={{
                key: '',
                name: '',
                description: '',
                status: 'Enabled',
            } as BillingProvider}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
